import { log } from '../../services/utils';

import { downloadAsset } from './assets';

import { noraApiRequest } from './';

export const getSubmissionReport = async submissionID => {
	log( 'getDocument' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: `report/submission/${ submissionID }`
	} );

	try {
		await downloadAsset( response.data );

		return true;
	} catch ( error ) {
		return error;
	}
};
